export enum OrderDetailsStatus {
  UNPAID = 'UNPAID',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_OVERDUE = 'PAYMENT_OVERDUE',
  PAID = 'PAID',
  HOLD = 'HOLD',
  CLOSED = 'CLOSED',
  CANCELED_REFUNDED = 'CANCELED_REFUNDED',
  CANCELED_HAS_CANCELLATION_FEE = 'CANCELED_HAS_CANCELLATION_FEE',
  CANCELED = 'CANCELED',
  // B-Stock cannot observe the buyer's payment to the seller, so no
  // payment-derived status is honest for an open Seller Collects order.
  SELLER_COLLECTS = 'SELLER_COLLECTS',
}
